/* ============================================
   AUREA NAILS - Theme JavaScript
   ============================================ */

(function () {
  'use strict';

  /* --- Mobile Menu Toggle --- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');

  function openMenu() {
    mobileNav.classList.add('is-active');
    menuOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    mobileNav.classList.remove('is-active');
    menuOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
    menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.contains('is-active');
      isOpen ? closeMenu() : openMenu();
    });
  }

  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeMenu);
  }

  /* ==============================
     CART DRAWER (AJAX-powered)
     ============================== */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartBody = document.querySelector('[data-cart-items]');
  var cartEmpty = document.querySelector('[data-cart-empty]');
  var cartFooter = document.querySelector('[data-cart-footer]');
  var cartSubtotalEl = document.querySelector('[data-cart-subtotal]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    if (!cartBody || !cartFooter || !cartEmpty) return;

    /* Update header cart count */
    cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (cart.item_count === 0) {
      cartBody.hidden = true;
      cartFooter.hidden = true;
      cartEmpty.hidden = false;
      return;
    }

    cartEmpty.hidden = true;
    cartBody.hidden = false;
    cartFooter.hidden = false;

    cartBody.innerHTML = '';
    cart.items.forEach(function (item, index) {
      var row = document.createElement('div');
      row.className = 'cart-drawer__item';
      row.innerHTML =
        '<a href="' + item.url + '" class="cart-drawer__item-image">' +
          (item.featured_image && item.featured_image.url ? '<img src="' + item.featured_image.url + '" alt="' + item.title + '">' : '') +
        '</a>' +
        '<div class="cart-drawer__item-details">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
          '<p class="cart-drawer__item-price">' + formatMoney(item.price) + '</p>' +
          '<div class="cart-drawer__item-controls">' +
            '<div class="cart-drawer__qty">' +
              '<button type="button" data-drawer-qty-change data-line="' + (index + 1) + '" data-delta="-1" aria-label="Decrease">−</button>' +
              '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
              '<button type="button" data-drawer-qty-change data-line="' + (index + 1) + '" data-delta="1" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer__item-remove" data-drawer-remove data-line="' + (index + 1) + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-drawer__item-line-total">' + formatMoney(item.line_price) + '</div>';
      cartBody.appendChild(row);
    });

    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  /* Cart icon click → open drawer */
  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });

  /* Close controls */
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* Close drawer when clicking empty-state nav link */
  document.querySelectorAll('[data-cart-close-nav]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  /* Drawer quantity +/- buttons */
  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-drawer-qty-change]');
      var removeBtn = e.target.closest('[data-drawer-remove]');

      if (qtyBtn) {
        e.preventDefault();
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
        var currentQty = parseInt(qtyBtn.parentNode.querySelector('.cart-drawer__qty-value').textContent, 10);
        var newQty = Math.max(0, currentQty + delta);
        cartDrawer.classList.add('is-loading');
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: newQty })
        }).then(function (r) { return r.json(); }).then(function (cart) {
          renderCart(cart);
          cartDrawer.classList.remove('is-loading');
        });
      }

      if (removeBtn) {
        e.preventDefault();
        var rLine = parseInt(removeBtn.getAttribute('data-line'), 10);
        cartDrawer.classList.add('is-loading');
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: rLine, quantity: 0 })
        }).then(function (r) { return r.json(); }).then(function (cart) {
          renderCart(cart);
          cartDrawer.classList.remove('is-loading');
        });
      }
    });
  }

  /* ==============================
     PRODUCT FORM - AJAX add to cart + dynamic price button
     ============================== */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    var form = btn.closest('form');
    if (!form) return;
    var unitPrice = parseInt(btn.getAttribute('data-unit-price'), 10);
    var label = btn.querySelector('[data-add-to-cart-label]');
    var qtyInput = form.querySelector('[name="quantity"]');

    function updatePriceLabel() {
      if (!label) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var total = unitPrice * qty;
      label.textContent = 'Add to Cart — ' + formatMoney(total);
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', updatePriceLabel);
      qtyInput.addEventListener('input', updatePriceLabel);
    }
    updatePriceLabel();

    /* AJAX submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      btn.disabled = true;
      var original = label ? label.textContent : btn.textContent;
      if (label) label.textContent = 'Adding…';

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function () {
        btn.disabled = false;
        if (label) label.textContent = original;
        openCart();
      })
      .catch(function () {
        btn.disabled = false;
        if (label) label.textContent = original;
        alert('Sorry, we could not add this item. Please try again.');
      });
    });
  });

  /* --- Sticky Header: transparent → white on scroll --- */
  var header = document.querySelector('[data-header]');
  var announcementBar = document.querySelector('.announcement-bar');
  var mainContent = document.getElementById('main-content');
  var isIndex = document.body.classList.contains('template-index');

  if (header) {
    var barHeight = announcementBar ? announcementBar.offsetHeight : 0;

    /* Push main content below the fixed header (skip on homepage where hero sits behind it) */
    if (!isIndex && mainContent) {
      mainContent.style.paddingTop = (barHeight + header.offsetHeight) + 'px';
    }

    function updateHeader() {
      var scrolled = window.scrollY >= barHeight;
      header.style.top = scrolled ? '0' : (barHeight - window.scrollY) + 'px';
      header.classList.toggle('is-scrolled', scrolled);
    }
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* --- Product Card Image Slideshow on Hover --- */
  var SLIDE_INTERVAL = 2000;

  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var images = card.querySelectorAll('.product-card__img');
    var dots = card.querySelectorAll('.product-card__progress-dot');
    if (images.length < 2) return;

    var currentIndex = 0;
    var timer = null;

    function showSlide(index) {
      images.forEach(function (img) { img.classList.remove('is-active'); });
      dots.forEach(function (dot) { dot.classList.remove('is-active'); });
      images[index].classList.add('is-active');
      dots[index].classList.add('is-active');
      currentIndex = index;
    }

    function nextSlide() {
      showSlide((currentIndex + 1) % images.length);
    }

    function startSlideshow() {
      card.classList.add('is-hovering');
      nextSlide();
      timer = setInterval(nextSlide, SLIDE_INTERVAL);
    }

    function stopSlideshow() {
      card.classList.remove('is-hovering');
      clearInterval(timer);
      timer = null;
      showSlide(0);
    }

    card.addEventListener('mouseenter', startSlideshow);
    card.addEventListener('mouseleave', stopSlideshow);
  });

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
